export default __webpack_public_path__ + "static/media/ethereum.f1c4bbde.svg";